import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { MetricCardHeader } from '../metrics';

import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MatCardModule } from '@angular/material/card';

@Component({
  selector: 'app-loading-state-card',
  templateUrl: './loading-state-card.component.html',
  styleUrls: ['./loading-state-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [CommonModule, TranslateModule, MatCardModule],
})
export class LoadingStateCardComponent {
  @Input() header: MetricCardHeader;
  @Input() showGraphArea = true;
}
